// extracted by mini-css-extract-plugin
module.exports = {"tagContent":"tags_tagContent__1DXoW"};